'use client';

import { usePathname } from 'next/navigation';
import { AppHeader } from './AppHeader';
import { AppFooter } from './AppFooter';
import { MarketingFooter } from '../marketing/MarketingFooter';
import { ClientBootstrap } from '../ClientBootstrap';
import { EmailVerificationBanner } from '../shared/EmailVerificationBanner';

export function AppShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isDashboard = pathname.startsWith('/admin') || pathname.startsWith('/seller');

  return (
    <>
      <ClientBootstrap />
      {isDashboard ? (
        <div className="min-h-screen bg-gray-50">{children}</div>
      ) : (
        <div className="flex min-h-screen flex-col">
          <EmailVerificationBanner />
          <AppHeader />
          <main className="flex-1">{children}</main>
          <MarketingFooter />
        </div>
      )}
    </>
  );
}

